import { RichTextTitle } from './richTextTitle';

export default RichTextTitle;
